// Параметры списка «Мои заказы» (вкладка и страница), которые нужно сохранять при переходах
export function bccOrdersQuery(query: Record<string, any> = {}) {
    const result: Record<string, string> = {}
    if (typeof query.tab === 'string' && query.tab) {
        result.tab = query.tab
    }
    const page = Number(query.page)
    if (Number.isInteger(page) && page > 1) {
        result.page = String(page)
    }
    return result
}
